import styled, { css } from "styled-components";
import { views } from "../../constants";
export const StyledPopup = styled.div`
  top: -10px;
  width: 275px;
  max-width: 275px !important;

  p {
    margin: 0;
  }

  .mapboxgl-popup-content {
    padding: 0;
    ${(props) =>
      !props.$showDetails &&
      css`
        border: none;
      `}
  }
  .mapboxgl-popup-close-button {
    line-height: 15px;
    top: 5px;
    right: 5px;
    color: #333;
    background: #fff;
    width: 15px;
    height: 15px;
    padding: 0;
    border-radius: 50%;
  }
  .mapboxgl-popup-tip {
    ${(props) =>
      props.$showDetails === false &&
      css`
        border-top-color: ${props.$mapView === views.S4S_GRANTEES
      ? `var(--color-tertiary)`
      : `var(--color-primary)`} !important;
      `}
  }
`;
export const PopupHeader = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  color: #fff;
  padding: 8px 10px;
  background: ${(props) =>
    props.$mapView === views.S4S_GRANTEES
      ? `var(--color-tertiary)`
      : `var(--color-secondary)`};

  span {
    color: var(--color-primary);
  }
`;

export const PopupTitle = styled.h3`
  font-family: var(--font-primary);
  font-weight: 500;
  line-height: 1.2;
  margin: 0;
`;

export const PopupSubtitle = styled.p`
  margin: 0;
  text-transform: uppercase;
  font-size: 10px;
  line-height: 1.2;
`;

export const PopupContent = styled.div`
  /* height: 90px; */
  min-height: 70px;
  padding: 10px;
  overflow-y: auto;
  color: var(--color-primary);
  line-height: 1.2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  span {
    font-family: var(--font-primary);
  }

  a {
    margin-top: 10px;
    color: var(--color-accent);
    font-size: 10px;
    text-transform: uppercase;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    row-gap: 2px;
  }
`;

export const PopupContentTitle = styled.h2`
  margin: 0 0 5px 0;
  font-size: 13px;
`;
